module.exports = __webpack_public_path__ + "img/why-icon-3.8f4f5918.svg";